<template>
  <a :href="action" class="btn" :class="buttonStyle">{{ this.buttonText }}</a>
</template>

<script>
export default {
  props: ["buttonText", "buttonSize", "animated", "green", "action", "yellow"],
  computed: {
    buttonStyle() {
      return {
        "btn--small": this.isButtonSmallSize(),
        "btn--medium": this.isButtonMediumSize(),
        "btn--green": this.isButtonGreen(),
        "btn--animated": this.isButtonAnimated(),
        "btn--yellow": this.isButtonYellow(),
      };
    },
  },
  methods: {
    isButtonSmallSize() {
      if (this.buttonSize === "sm") {
        return true;
      }
    },
    isButtonMediumSize() {
      if (this.buttonSize === "md") {
        return true;
      }
    },
    isButtonBigSize() {
      if (this.buttonSize === "bg") {
        return true;
      }
    },
    isButtonAnimated() {
      if(this.animated === "true") {
        return true;
      }
      return false;
    },
    isButtonGreen() {
      return this.green ? true : false;
    },
    isButtonYellow() {
      return this.yellow ? true : false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../sass/_variables.scss";
@import "../../sass/_animations.scss";

.btn {
  &,
  &:link,
  &:visited {
    text-transform: uppercase;
    text-decoration: none;
    padding: 2rem 4rem;
    display: inline-block;
    border-radius: 4rem;
    transition: all 0.2s;
    position: relative;

    //change for the <button>
    border: none;
    cursor: pointer;
  }

  &:hover {
    transform: translateY(-0.3rem);
    box-shadow: 0 1rem 2rem rgba($color-black, 0.2);

    &::after {
      transform: scaleX(1.4) scaleY(1.6);
      opacity: 0;
    }
  }

  &:active,
  &:focus {
    outline: none;
    transform: translateY(0.1rem);
    box-shadow: 0 0.5rem 0.1rem rgba($color-black, 0.5);
  }

  &--white {
    background-color: $color-white;
    color: $color-grey-dark;

    &::after {
      background-color: $color-white;
    }
  }

  &--green {
    background-image: linear-gradient(
      to right bottom,
      $color-tertiary-light,
      $color-tertiary-dark
    );
    color: $color-white;

    &::after {
      background-image: linear-gradient(
        to right bottom,
        $color-tertiary-light,
        $color-tertiary-dark
      );
    }
  }

  &--yellow {
    background-image: linear-gradient(
      to right bottom,
      $color-secondary-light,
      $color-secondary-dark
    );
    color: $color-white;

    &::after {
      background-image: linear-gradient(
        to right bottom,
        $color-secondary-light,
        $color-secondary-dark
      );
    }
  }

  &--big {
    //TODO dodat i padding da se moze skroz naštimat. Maknut gore
    font-size: 1.4rem;
  }

  &--medium {
    font-size: 1.5rem;
  }

  &--small {
    font-size: 1rem;
  }

  &::after {
    content: "";
    display: inline-block;
    height: 100%;
    width: 100%;
    border-radius: 10rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    transition: all 0.4s;
  }

  &--animated {
    animation: moveInBottom 0.5s ease-out 0.75s;
    animation-fill-mode: backwards;
  }
}

.btn-text {
  &:link,
  &:visited {
    font-size: $default-font-size;
    color: $color-primary;
    display: inline-block;
    text-decoration: none;
    border-bottom: 0.1rem solid $color-primary;
    padding: 0.3rem;
    transition: all 0.2s;
  }

  &:hover {
    background-color: $color-primary;
    color: $color-white;
    box-shadow: 0 1rem 2rem rgba($color-black, 0.15);
    transform: translateY(-.2rem);
  }

  &:active {
    box-shadow: 0 0.5rem 1rem rgba($color-black, 0.15);
    transform: translateY(0);
  }
}
</style>
